module.exports = __webpack_public_path__ + "img/btn_auto_stop_on.d82320cf.jpg";